import { LINKTAGSARRAY } from '@qaroni-core/types/metadata/link-tags.array';

const linkStylePromise = (): Promise<void> => {
  return new Promise(resolve => {
    LINKTAGSARRAY.forEach(tag => {
      const link = document.createElement('link');
      link.rel = tag.rel;
      link.href = tag.href;

      if (tag.type) {
        link.type = tag.type;
      }

      if (tag.sizes) {
        Object.defineProperty(link, 'sizes', {
          value: tag.sizes,
          writable: true,
        });
      }
      document.head.appendChild(link);
    });

    resolve();
  });
};

export function initializeLinkStyle(): () => Promise<void> {
  return () => linkStylePromise();
}
